import PropTypes from "prop-types"
import styled from "styled-components"
import { headlineTextTheme } from "../../theme"
import { fontBold } from "../../utils/fontFamily"

const H3 = styled.h3`
  color: ${({ whiteText }) => (whiteText ? "#ffff" : headlineTextTheme)};
  ${fontBold()}
  line-height: 1.5;
  margin-bottom: 0;
  
  ${({ theme }) => theme.se`
   font-size: 24px;
  `}

  ${({ theme }) => theme.tablet`
   font-size: 26px;
  `}

  ${({ theme }) => theme.desktop`
   font-size: 30px;
  `}
`

H3.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  whiteText: PropTypes.bool,
}

H3.defaultProps = {
  whiteText: false,
}

export default H3
